import CopyIconPath from "@ingka/ssr-icon/paths/copy";

export default CopyIconPath;
